/**
 * @description Simple hook that retrieves the personnel sync mappings
 */
import React from 'react';

import { ToastContext } from '@seccon/core/contexts/toast';
import decodeJson from '@seccon/shared/utils/decodeJson';

const useMapList = () => {
  const [mapList, setMapList] = React.useState(null);
  const toastApi = React.useContext(ToastContext);

  /**
   * Handles API successes by storing the list of maps
   * @param response {{ id: number, name: string, syncOnSsn: boolean }[]} - list of maps
   */
  function handleSuccess (response) {
    setMapList(
      response
        .map((entry) => ({
          id: entry.id,
          name: entry.name,
          syncOnSsn: entry.syncOnSsn
        }))
        // Sort the map list alphabetically (case insensitive)
        .sort((entryA, entryB) => entryA.name.localeCompare(entryB?.name, 'en', { sensitivity: 'base' }))
    );
  }

  /**
   * Handles API failures by notifying the user
   */
  function handleFailure () {
    toastApi.error('Personnel Mapping Definition list could not be retrieved. Reload the page and try again.');
  }

  // On mount, if the list is not retrieved yet, run the API request
  React.useEffect(() => {
    if (mapList !== null) {
      return;
    }

    fetch('/mappings')
      .then(decodeJson)
      .then(handleSuccess)
      .catch(handleFailure);
  }, []);

  return mapList;
};

export default useMapList;
